import { render, staticRenderFns } from "./edit_report.vue?vue&type=template&id=84be2cb4&scoped=true"
import script from "./edit_report.vue?vue&type=script&lang=js"
export * from "./edit_report.vue?vue&type=script&lang=js"
import style0 from "./edit_report.vue?vue&type=style&index=0&id=84be2cb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be2cb4",
  null
  
)

export default component.exports